@if (!errorMessage) {
  <rotec-modal-v2
    [darkMode]="true"
    [width]="width"
    [height]="height"
    [title]="edit ? 'Edit User' : 'Add User'"
    [showCloseIcon]="!(loading$ | async)"
  >
    @if (!(loading$ | async)) {
      <ng-container ngProjectAs="modal-main">
        <form [formGroup]="form">
          @if (!edit) {
            <ng-container
              *ngTemplateOutlet="
                textInputRow;
                context: { name: 'E-Mail Address', control: form.get('email') }
              "
            ></ng-container>
          }
          <ng-container
            *ngTemplateOutlet="
              textInputRow;
              context: { name: 'First Name', control: form.get('givenName') }
            "
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="
              textInputRow;
              context: { name: 'Last Name', control: form.get('surname') }
            "
          ></ng-container>
          <div class="user-modal-row _flex-row">
            <div class="row-title"><p translate>Role</p></div>
            <div class="row-input">
              <rotec-select-v2
                [darkMode]="true"
                [secondary]="true"
                [items]="USER_ROLES"
                [hasError]="hasControlError(form.get('role'))"
                formControlName="role"
              ></rotec-select-v2>
            </div>
          </div>
          <ng-template #textInputRow let-control="control" let-name="name">
            <div class="user-modal-row _flex-row">
              <div class="row-title _flex-row">
                <p>{{ name | translate }}</p>
                <rotec-icon-v2
                  [svgIcon]="!control?.valid ? 'asterisk' : 'check'"
                  [color]="!control?.valid ? 'pink' : 'light-gray'"
                ></rotec-icon-v2>
              </div>
              <div class="row-input">
                <rotec-text-input-v2
                  [darkMode]="true"
                  [hasError]="hasControlError(control)"
                  [formControl]="control"
                  required
                ></rotec-text-input-v2>
                <div class="error">
                  @if (control.errors?.errorMessage; as message) {
                    {{ message | translate }}
                  }
                </div>
              </div>
            </div>
          </ng-template>
        </form>
      </ng-container>
    } @else {
      <div [style.flex-direction]="'inherit'">
        <div class="spinner-snake"></div>
      </div>
    }
    <ng-container ngProjectAs="modal-buttons">
      <button rotec-button-secondary dark [disabled]="loading$ | async" (click)="close()">
        {{ 'Cancel' | translate }}
      </button>
      <button
        dark
        rotec-button-active
        [disabled]="(loading$ | async) || form.invalid"
        (click)="save()"
      >
        {{ (edit ? 'Update' : 'COMMON_Create') | translate }}
      </button>
    </ng-container>
  </rotec-modal-v2>
} @else {
  <wm-error-modal
    [width]="width"
    [height]="height"
    [text]="errorMessage"
    (close)="closeErrorModal()"
  ></wm-error-modal>
}
